var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendGiftStep3 = function SvgSendGiftStep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 78,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFF1F3",
    fillRule: "nonzero",
    opacity: 0.649,
    cx: 34.5,
    cy: 34.5,
    r: 34.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#93A1AC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.833 72.704a3.18 3.18 0 0 1-3.174 3.178H33.29a3.18 3.18 0 0 1-3.174-3.178V36.296a3.18 3.18 0 0 1 3.174-3.178h36.369a3.18 3.18 0 0 1 3.174 3.178V48.58L62.376 59.048a1.4 1.4 0 0 0-.405.835l-.516 4.308a.898.898 0 0 0 .257.745.896.896 0 0 0 .746.259l4.3-.516a1.419 1.419 0 0 0 .837-.407l5.238-5.243v13.675Zm-8.587-8.79-1.51-1.513.286-2.396a.324.324 0 0 1 .015-.064l3.66 3.664c-.022.006-.039.02-.06.022l-2.391.287Zm17.34-15.65-3.219-3.223a1.416 1.416 0 0 0-2 0l-1.418 1.42V36.297A5.299 5.299 0 0 0 69.659 31H33.29A5.299 5.299 0 0 0 28 36.296v36.408A5.299 5.299 0 0 0 33.29 78h36.369a5.299 5.299 0 0 0 5.29-5.296V56.911l6.637-6.645a1.418 1.418 0 0 0 0-2.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.325 45h29.35c.729 0 1.325-.675 1.325-1.5s-.596-1.5-1.325-1.5h-29.35c-.729 0-1.325.675-1.325 1.5s.596 1.5 1.325 1.5M35.325 52h29.35c.729 0 1.325-.675 1.325-1.5s-.596-1.5-1.325-1.5h-29.35c-.729 0-1.325.675-1.325 1.5s.596 1.5 1.325 1.5M51.677 55H35.323c-.728 0-1.323.675-1.323 1.5s.595 1.5 1.323 1.5h16.354c.727 0 1.323-.675 1.323-1.5s-.596-1.5-1.323-1.5M51.677 62H35.323c-.728 0-1.323.675-1.323 1.5s.595 1.5 1.323 1.5h16.354c.727 0 1.323-.675 1.323-1.5s-.596-1.5-1.323-1.5"
  })))));
};
export default SvgSendGiftStep3;